// extracted by css-extract-rspack-plugin
export default {"root":"root-XDYxpN text-sm-medium","resultCount":"resultCount-gjotIj"};